import { Component,  Vue , Watch} from 'vue-property-decorator'
import HorizontalBarChart from '@/assets/common/HorizontalBarChart/HorizontalBarChart.vue';
import moment from "moment";
import { CsvDownload } from '@/types/APIResponse'
import EmptyGraphMessage from '@/assets/common/AggregationFunction/EmptyGraphMessage/EmptyGraphMessage.vue';

interface DatasetItem {
  label: string;  
  data: (string | number)[]; 
  backgroundColor: string; 
  barThickness: number;
}

@Component({
  components: {
      HorizontalBarChart,
      EmptyGraphMessage
  }
})
export default class WorkResultByPlantings extends Vue {
  baseUrl = '/work_result_planting';    
  selectScreenManagement = '/graphScreenManagement';    
  selectedCropOrPlantingsId : string | null = null;
  selectedPlantingOrCropName ="" 
  private selectedWorkId : string | null = null;
  selectedWorkName=""
  selectedStartDate: string | Date = new Date();
  selectedEndDate: string | Date = new Date();
  startDate: string | Date = new Date();
  endDate: string | Date = new Date();
  selectedPlantingsOrCrops = 0
  private lastSetOption = false;
  private workItemList=[] as any[]
  private plantingsList=[]
  private cropsList=[]
  private plantingOrCropList=[] as any[]
  private totalTimeTakenArr = [] as any[]
  private totalTimeTakenArrInHrs = [] as any[]
  private overAllTimeTaken : string | null = null;
  private isButtonDisabled = false
  //chart props
  private chartData = {} as any
  private options = {} as any
  private responseChartArr = {}

  //chatdata parameters
  label = [] as string[]
  dataset: DatasetItem[] = [];
  lableTotalArr = []
  private dataEmptyFlag = false;
  private presetColors = [
    "#66BAA7",
    "#EE7D6F",
    "#64AAC1",
    "#F5EB7D",
    "#D46C9B",
    "#ACD26B",
    "#7C79B1",
    "#7CC17B",
    "#6698C0",
    "#F4AF6C",
    "#A76FAC",
    "#EB6F86",
    "#64A676",
    "#CF7655",
    "#4E8792",
    "#C4B54A",
    "#A84E72",
    "#93C534",
    "#CF4A8B",
    "#426BBE"
  ];
  includeHiddenFlag = false;

  created() {
    const currentDate = new Date();
    this.selectedStartDate = moment(currentDate).startOf('month').format('YYYY-MM-DD');
    this.selectedEndDate = moment(currentDate).endOf('month').format('YYYY-MM-DD');
    this.startDate = this.selectedStartDate;
    this.endDate = this.selectedEndDate;
    this.getWorkResultByPlantings()
    this.getWorkItems()
    this.getPlantings()
    this.getCrops()
    this.dataEmptyFlag = true;
  }

  getWorkResultByPlantings() {
    this.$apiClient.doRequest('get', `${this.baseUrl}`).then(res => {
      if(res.filterArray !=null){
      this.plantingOrCropList = res.filterArray.cropId || this.lastSetOption ? this.cropsList : this.plantingsList
      this.selectedPlantingsOrCrops = res.filterArray.cropId || this.lastSetOption ? 1 : 0;
      this.selectedCropOrPlantingsId = res.filterArray.cropId ? res.filterArray.cropId : res.filterArray.agriFieldId
      this.selectedWorkId = res.filterArray.workItemId
      this.selectedStartDate = res.filterArray.displayFromDate ? res.filterArray.displayFromDate : ""
      this.selectedEndDate = res.filterArray.displayToDate ? res.filterArray.displayToDate : ""
      this.startDate = res.filterArray.displayFromDate ? res.filterArray.displayFromDate : ""
      this.endDate = res.filterArray.displayToDate ? res.filterArray.displayToDate : ""
      this.includeHiddenFlag = res.filterArray.includeHiddenFlag
      }
      this.responseChartArr= {
        plantings:res.cropsArr,
        work:res.workArr,
        workTimeTaken:res.workTimeTakenMap
      }
      this.overAllTimeTaken = null
      this.setChartDataFromApiData(this.responseChartArr)
      if(res.workResultByCrops.length===0){
        this.dataEmptyFlag = false;
      }
      if ((this.selectedStartDate > this.selectedEndDate) || (this.selectedStartDate === '' && this.selectedEndDate === '') || (this.selectedStartDate === '' && this.selectedEndDate !== '') 
        || (this.selectedStartDate !== '' && this.selectedEndDate === '')) {
        this.isButtonDisabled = true;
        this.plantingOrCropList = [];
          }else{
            this.isButtonDisabled = false;
          } 
    })
  }

  //fetch necessory dropdown values
  getWorkItems(){
    this.$apiClient.doRequest('get','/work_items?with_hidden=true').then((res) => {
      this.workItemList = res.work_items
    });
  }

  getPlantings(){
    this.$apiClient.doRequest('get','/agri_fields?with_hidden=true').then((res) => {
      this.plantingsList = res.agri_fields.sort((a:any,b:any) => a.name.localeCompare(b.name))
      this.plantingOrCropList = !this.selectedPlantingsOrCrops ? this.plantingsList : this.cropsList
    });
  }

  getCrops(){
     this.$apiClient.doRequest('get', `/crops/cropBytenentId`).then(res => {
      this.cropsList = res.crops;
      this.cropsList.sort((a:any, b:any) => a.name.localeCompare(b.name));
      this.plantingOrCropList = !this.selectedPlantingsOrCrops ? this.plantingsList : this.cropsList
      this.selectedPlantingOrCropName= this.plantingOrCropList.find(item=>item.id==this.selectedCropOrPlantingsId)?.name
      this.selectedWorkName = this.workItemList.find(item=>item.id==this.selectedWorkId)?.name
    })
  }
  
  setChartDataFromApiData(data:any){
    data.plantings = data.plantings.map((item: string | null) => (item === null ? "作付がない記録" : item)).sort((a: string, b: string) => (a === "作付がない記録" ? 1 : b === "作付がない記録" ? -1 : 0));
    //WorkTotalTime Calculation
    if (Object.keys(data.workTimeTaken).length > 0) {
      const workTimeTaken: any[] = Object.values(data.workTimeTaken);
      const maxLength = Math.max(...workTimeTaken.map((arr: any[]) => arr.length));
      this.totalTimeTakenArr = Array.from({ length: maxLength }, (_, index) => {
        return workTimeTaken.reduce((partialSum, array) => {
          const value = parseInt(array[index]) || 0;
          return partialSum + value;
        }, 0);
      });
      this.totalTimeTakenArrInHrs = this.hoursConversionFun(this.totalTimeTakenArr);
      const totalWorkTime = this.totalTimeTakenArr.reduce((total, value) => total + value, 0);
      this.overAllTimeTaken = `${Math.floor(totalWorkTime / 60)}時間${totalWorkTime % 60}分`;
    }
    if (data.plantings.includes("作付がない記録")) {
      // Move the first element to the last position
      const firstElement = this.totalTimeTakenArr.shift(); // Remove the first element
      if (firstElement !== undefined) {
        this.totalTimeTakenArr.push(firstElement); // Add it to the end
      }
    }
    this.label = data.plantings
    this.dataset = data.work?.map((item: string, index: number): DatasetItem => ({
      label: item,
      data: this.hoursConversionFun(data.workTimeTaken[item]) as (string | number)[],
      backgroundColor: this.presetColors[index % this.presetColors.length],
      barThickness: 30,
    })) as DatasetItem[];

    if (data.plantings.includes("作付がない記録") && this.dataset) {
      this.dataset = this.dataset.map((datasetItem) => {
        const dataArray = datasetItem.data;  
        if (dataArray && dataArray.length > 0) {
          const firstDataValue = dataArray.shift(); 
          if (firstDataValue !== undefined) dataArray.push(firstDataValue);
        }
        return datasetItem;
      });
    }
    this.dataEmptyFlag=true;
  }
  
  //Total time label inclusion (y axis)
  plugins = [{
    afterDraw: function(chart:any) {
      const yScale = chart.scales['y-axis-0'];
      const yPos = yScale.bottom;
      const ctx = chart.ctx;
      ctx.save();
      ctx.textBaseline = 'middle';
      ctx.font = 'lighter 10px arial';
      ctx.fillText('合計時間(時間 : 分)', yScale.right - 90 , yPos - 6)
      ctx.restore();
    }
  }]

  //setChart data values 
  @Watch("responseChartArr")
  setChartData(){
    this.chartData={
      labels: this.label,
      datasets: this.dataset
    }
    this.options={
        layout: {
          padding: {
            left: 50,
            right: 20,
            top: 20,
            bottom: 0
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        plugins:{
          datalabels: 
          {
            color: "black",
            textAlign: "center",
            align:'right',
            anchor:'end',
            fontFamily: "'Open Sans Bold', sans-serif",
            formatter: (value :any, context:any) => {
            if (context.datasetIndex === context.chart.data.datasets.length - 1) {
              return `${Math.trunc(this.totalTimeTakenArr[context.dataIndex] / 60).toString().padStart(1, '0')+'時間'}${(this.totalTimeTakenArr[context.dataIndex] % 60).toString().padStart(1, '0')+'分'}`;
            }
             else {
              return '';
            }
            },
            font: {
              size: 13       
            }
          }
        },
        tooltips: {
          mode:"nearest",
          callbacks:{
            title:function(tooltipItem:any,data:any){
              return tooltipItem[0].label
            },
            label:function (tooltipItem: any, data: any){
              const datasetLabel = data.datasets[tooltipItem.datasetIndex].label;
              const value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
              const [hours, minutes] = value.split('.');
              const formatHours = Number(hours).toString();
              const formatMinutes =Number(minutes).toString()
              const formattedTime = `${formatHours}時間${formatMinutes}分`;
              return datasetLabel + ': ' + formattedTime;
            }
          }    
        },
        legend:{
          position:"bottom",
          align :"start"
        },
        scales: {
            xAxes: [{
                position:'bottom',
                type:"linear",
                ticks: {
                  stepSize:5,
                  beginAtZero:true,
                  suggestedMax:Math.max(...this.totalTimeTakenArrInHrs)*1.2,
                  fontFamily: "'Open Sans Bold', sans-serif",
                  fontSize:11,
                  callback:(value:any)=>{
                    return value+"時間"
                  }
                },
                gridLines: {
                  display:true
                }, 
                stacked: true
            }],
            yAxes: [{
                ticks: {
                    fontFamily: "'Open Sans Bold', sans-serif",
                    fontSize:11,
                    callback: (value:any, index:any,values:any)=> {
                      return (value && value.length >10 ? value.substring(0,12) +"...": value )
                    },
                },
                stacked: true,
            }]
        },
    }
  }

  //hour conversion for comparison
  hoursConversionFun(timeConsumedinMins:any) {
    return timeConsumedinMins?.map((item:any)=>{
      const hm = Math.trunc(item / 60)
      const mm = item % 60;
      const result = hm.toString().padStart(2,'0')+"."+mm.toString().padStart(2,'0')
      return result
    })
  }
  
  get setStyle() {
    let height = (this.label.length * 100 +  60)  
    const CANVAS_HEIGHT_LIMIT = 32767
    height = (height > CANVAS_HEIGHT_LIMIT) ? CANVAS_HEIGHT_LIMIT : height
    return {
        position: 'relative',
        width: 'calc(100% - 10px)',
        height: height + 'px'
    }
  }

  handleSelectChange(flag = true) {
    this.selectedPlantingOrCropName= this.plantingOrCropList.find(item=>item.id==this.selectedCropOrPlantingsId)?.name
    this.selectedWorkName = this.workItemList.find(item=>item.id==this.selectedWorkId)?.name
    const params = {
      cropId: this.selectedPlantingsOrCrops ? this.selectedCropOrPlantingsId : null,
      agriFieldId: !this.selectedPlantingsOrCrops ? this.selectedCropOrPlantingsId : null,
      selectedWorkId: this.selectedWorkId,
      startDate: this.selectedStartDate,
      endDate: this.selectedEndDate,
      screenName:'WORKRESULTBYPLANTING',
      includeHiddenFlag: this.includeHiddenFlag
    }
    this.$apiClient.doRequest('post', `${this.selectScreenManagement}`,params).then(res => {
      if (flag) {
        this.getWorkResultByPlantings();
      }
    })
  } 

  handlePlantingsCropSelect () {
    this.plantingOrCropList = !this.selectedPlantingsOrCrops ? this.plantingsList : this.cropsList
    this.selectedCropOrPlantingsId=null
    this.lastSetOption = this.selectedPlantingsOrCrops ? true : false;
    this.handleSelectChange();
  }

  validateDates() {
    if (!this.selectedStartDate || !this.selectedEndDate) return;
    if (this.selectedStartDate > this.selectedEndDate) {
      this.selectedStartDate = this.startDate;
      this.selectedEndDate = this.endDate;
      this.isButtonDisabled = true;
    } else {
      this.isButtonDisabled = false;
      this.startDate = this.selectedStartDate;
      this.endDate = this.selectedEndDate;
    }
  }

  exportCsv() {
    this.$apiClient.getRequest( `${this.baseUrl}/csv_export?&selected_planting_or_crop=${this.selectedPlantingsOrCrops}&start_date=${this.selectedStartDate}&end_date=${this.selectedEndDate}&crop_or_planting=${this.selectedPlantingOrCropName?this.selectedPlantingOrCropName:""}&work_item_name=${this.selectedWorkName?this.selectedWorkName:""}`).then((res: CsvDownload) => {
        this.$apiClient.csvDownload(res)
    })
  }

  dateNavigation(action: string) {
    if (!this.selectedStartDate || !this.selectedEndDate) return;
    this.validateDates()
    if(this.isButtonDisabled == false){
    const updateDate = (date: moment.MomentInput, offset: moment.DurationInputArg1, unit: moment.unitOfTime.Base) => moment(date).add(offset, unit).format('YYYY-MM-DD');
    const daysDifference = moment(this.selectedEndDate).diff(this.selectedStartDate, 'days')+1;
    const offset = (action === 'previous') ? -daysDifference : daysDifference;
    this.selectedStartDate = updateDate(this.selectedStartDate, offset, 'days');
    this.selectedEndDate = updateDate(this.selectedEndDate, offset, 'days');
    this.startDate = this.selectedStartDate;
    this.endDate = this.selectedEndDate;
    this.handleSelectChange();
    } else {
      this.isButtonDisabled = false
    }
  }

  get filterWorkItemList() {
    return this.includeHiddenFlag ? this.workItemList : this.workItemList.filter(wi => this.selectedWorkId == wi.id || !wi.is_hidden);
  }

  get filterPlantingOrCropList() {
    if (this.selectedPlantingsOrCrops) {
      return this.plantingOrCropList
    } else {
      return this.includeHiddenFlag ? this.plantingOrCropList : this.plantingOrCropList.filter(p => this.selectedCropOrPlantingsId == p.id || !p.is_hidden);
    }
  }
}